<template>
  <router-view></router-view>
  <vue3-toastify />
</template>

<script>
export default {
  name: "App",
};
</script>